<nav *ngIf="company !== 'TW'"  class="claims-nav">
    <div class="w-100 tab-navigation">
        <ul class="w-100 pl-0 d-table no-margin-bottom">
            <li routerLinkActive="active" class="w-50">
                <a routerLink="/claims/{{claimId}}/details"
                    title="{{ 'Claim details' | translate }}">{{ "Claim details" | translate }}</a>
            </li>
            <li routerLinkActive="active" class="w-50">
                <a routerLink="/claims/{{claimId}}/documents"
                    title="{{ 'Claim documents' | translate }}">{{ "Claim documents" | translate }}</a>
            </li>
        </ul>
    </div>
</nav>